import { State, StateView } from "../mvc/state";

class NavigationNode {
  view: StateView | null;
  previous: NavigationNode | null = null;
  next: NavigationNode | null = null;

  constructor(view: StateView | null) {
    this.view = view;
  }
}

export class SubdiagramNavigationHistory {
  private current: NavigationNode;
  private isNavigatingViaHistory = false;

  constructor() {
    this.current = new NavigationNode(null);
  }

  navigate(view: StateView | null) {
    if (this.isNavigatingViaHistory) {
      return;
    }

    const currentModelId = this.current.view?.model?.id;
    const newModelId = view?.model?.id;
    const isSameView = currentModelId === newModelId || (currentModelId === undefined && newModelId === undefined);

    if (isSameView) {
      return;
    }

    const newNode = new NavigationNode(view);
    newNode.previous = this.current;

    this.current.next = newNode;
    this.current = newNode;
  }

  private isNavigable(node: NavigationNode | null): boolean {
    if (node === null) {
      return false;
    }
    if (node.view === null) {
      return true;
    }
    const model = node.view.model as State;
    return model?.getSubdiagram() !== undefined;
  }

  canGoBack(): boolean {
    return this.isNavigable(this.current.previous);
  }

  canGoForward(): boolean {
    return this.isNavigable(this.current.next);
  }

  goBack(): StateView | null {
    if (this.canGoBack()) {
      this.isNavigatingViaHistory = true;
      this.current = this.current.previous!;
      return this.current.view;
    }
    return null;
  }

  goForward(): StateView | null {
    if (this.canGoForward()) {
      this.isNavigatingViaHistory = true;
      this.current = this.current.next!;

      return this.current.view;
    }
    return null;
  }

  completeNavigation() {
    this.isNavigatingViaHistory = false;
  }

  getCurrent(): StateView | null {
    return this.current.view;
  }

  clear() {
    this.current = new NavigationNode(null);
    this.isNavigatingViaHistory = false;
  }
}
